import { useSelector, useDispatch } from 'react-redux';
import { setDarkMode } from '../../Redux/store';
import { Moon, Sun } from 'lucide-react';

/** Display tab — dark mode toggle */
function DisplaySettings() {
  const darkMode = useSelector((s) => s.ui.darkMode);
  const dispatch = useDispatch();

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    dispatch(setDarkMode(newMode));
    
    // Save to localStorage
    localStorage.setItem('darkMode', newMode.toString());
    
    // Apply dark mode to document
    if (newMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <div className="space-y-4">
      <p className="text-xs text-muted-foreground">Customize your display preferences.</p>
      
      <div className="rounded-xl border border-border p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {darkMode ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
            <div>
              <div className="text-sm font-medium">Dark Mode</div>
              <div className="text-xs text-muted-foreground">Switch between light and dark themes</div>
            </div>
          </div>
          <button
            onClick={toggleDarkMode}
            className={`relative h-6 w-11 rounded-full transition-colors ${
              darkMode ? 'bg-primary' : 'bg-muted'
            }`}
          >
            <span
              className={`absolute top-1 left-1 h-4 w-4 rounded-full bg-background transition-transform ${
                darkMode ? 'translate-x-5' : 'translate-x-0'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default DisplaySettings;
